@if(pingLoder){
<div class="flex items-center space-x-1 text-dc-navy font-medium">
  @if(loadingText){<span>{{ loadingText }}</span
  >}
  <span class="flex space-x-1">
    <span class="animate-ping">›</span>
    <span class="animate-ping [animation-delay:150ms]">›</span>
    <span class="animate-ping [animation-delay:300ms]">›</span>
    <span class="animate-ping [animation-delay:450ms]">›</span>
    <span class="animate-ping [animation-delay:600ms]">›</span>
  </span>
</div>
} @else if(formLoader){
<!-- Form Fields Skeleton -->
<div class="flex items-center space-x-1 text-dc-navy font-medium pl-1.5 pr-1.5">
  <span>{{ "LOADER_TEXT" | translate }}</span>
  <span class="flex space-x-1">
    <span class="animate-ping">›</span>
    <span class="animate-ping [animation-delay:150ms]">›</span>
    <span class="animate-ping [animation-delay:300ms]">›</span>
    <span class="animate-ping [animation-delay:450ms]">›</span>
    <span class="animate-ping [animation-delay:600ms]">›</span>
  </span>
</div>
<div class="space-y-6 flex-col">
  <!-- Field Group Skeleton -->
  @for (i of [].constructor(noOfFields); let idx = $index; track idx) {
  <div class="p-2 animate-pulse space-y-2">
    <!-- Label -->
    <div class="h-4 w-1/4 bg-gray-200"></div>
    <!-- Input -->
    <div class="h-10 bg-gray-100"></div>
  </div>
  }
</div>
} @else {
<div class="p-4 animate-pulse space-y-3 bg-white">
  <div class="h-7 w-9/10 bg-gray-200"></div>
  <div class="h-6 w-7/9 bg-gray-100"></div>
  @for (i of [].constructor(noOfFields); let idx = $index; track idx) {
  <div class="h-6 w-5/6 bg-gray-100"></div>
  <div class="h-4 w-2/3 bg-gray-100"></div>
  <div class="h-2 w-1/2 bg-gray-100"></div>
  }
</div>
}
